import { render } from "./BizAddAnnouncement.vue?vue&type=template&id=00480970&scoped=true"
import script from "./BizAddAnnouncement.vue?vue&type=script&lang=js"
export * from "./BizAddAnnouncement.vue?vue&type=script&lang=js"

import "./BizAddAnnouncement.vue?vue&type=style&index=0&id=00480970&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00480970"]])

export default __exports__